import type { ParsedTable } from '../types'
import { toNumber } from '../generators/helpers'

/**
 * Validates if the parsed table data is suitable for rendering a Pie chart
 *
 * Pie charts work with a single column of data, where the generator will use
 * the selected header to determine which column to plot
 *
 * Checks:
 * - At least one row exists
 * - At least two columns exist (category + data)
 * - At least one valid numeric value exists in the data columns
 *
 * @param t - The parsed table data
 * @returns True if the data can be rendered as a pie chart, false otherwise
 */
export function canRenderPie(t: ParsedTable): boolean {
  if (t.rowCnt === 0 || t.colCnt < 2) {
    console.warn('canRenderPie: Need at least one row and two columns.')
    return false
  }

  // Check if there is at least one valid numeric data point in any data column
  for (let r = 0; r < t.rowCnt; r++) {
    for (let c = 1; c < t.colCnt; c++) {
      if (t.rows[r] && c < t.rows[r].length) {
        const num = toNumber(t.rows[r][c])
        if (num !== null && !isNaN(num) && num > 0) {
          return true
        }
      }
    }
  }

  console.warn('canRenderPie: No positive numeric data found.')
  return false
}
